<template>
  <div class="flex items-center">
    <label
      :for="inputId"
      class="inline-flex relative items-start cursor-pointer"
    >
      <input
        :id="inputId"
        v-model="isChecked"
        type="checkbox"
        class="sr-only peer"
        role="switch"
        :aria-label="ariaLabel || label"
      />

      <div
        :class="[
          'w-56',
          'min-w-56',
          'h-32',
          'bg-surface-action-2',
          'hover:bg-surface-action-hover',
          'rounded-full',
          'border-md',
          'border-border-primary',
          'peer-focus:outline',
          'peer-focus:outline-2',
          'peer-focus:outline-offset-input',
          'peer-focus:outline-border-highlight',
          'peer-checked:bg-surface-success',
          'peer-checked:hover:bg-surface-action-hover',
          'peer-checked:after:translate-x-[110%]',
          `after:content-['']`,
          'after:absolute',
          'after:left-4',
          'after:top-4',
          'after:bg-surface-information',
          'after:rounded-full',
          'after:h-22',
          'after:w-22',
          'after:transition-all',
          isChecked ? `before:content-['På']` : `before:content-['Av']`,
          'before:absolute',
          'before:top-4',
          isChecked ? 'before:left-8' : 'before:left-30',
          'before:text-16',
          'before:leading-22',
          'before:font-medium',
          isChecked
            ? 'before:text-text-on-highlight dark:before:hover:text-text-on-action-hover'
            : 'before:text-text-on-highlight dark:before:text-text-primary',
          'before:transition-all',
        ]"
      ></div>
      <span class="ms-8 my-0 md:my-3 heading-xxs">{{ label }}</span>
    </label>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  inputId: string;
  label: string;
  ariaLabel?: string;
}

defineProps<Props>();

const isChecked = defineModel<boolean>();
</script>
